export interface BaseTranslation {
  id: string;
  locale_id: string;
  translation: string;
}
